import {UPDATE_LIST_REPORTS, UPDATE_LOADING_REPORTS} from '@/modules/neodash/store/modules/reports/types';
import {Report} from '@/modules/neodash/model/types/interfaces/Report';
import {stateListReports} from '@/modules/neodash/store/modules/reports/state';

export const mutations = {
  [UPDATE_LIST_REPORTS]: (state: stateListReports, payload: Report[]) => {
    state.lstReports = payload
  },
  [UPDATE_LOADING_REPORTS]: (state: stateListReports, payload: boolean) => {
    const newValue = payload === undefined ? !state.isLoadingListReports : payload;

    state.isLoadingListReports = newValue;
  }
};
